"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const work_registration_forms_1 = require("@Const/work-registration-forms");
const react_helmet_1 = __importDefault(require("react-helmet"));
const WorkRegistrationWizardRoad_1 = __importDefault(require("@Components/WorkRegistrationWizardRoad"));
const FormBottomNavBar_1 = __importDefault(require("@Components/CreateWorkBottomNavs/FormBottomNavBar"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const CreateWorkByFormLayout = () => {
    const { rightsholderStore, workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const location = (0, react_router_dom_1.useLocation)();
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const [currentStepType, setCurrentStepType] = (0, react_1.useState)();
    const [backLink, setBackLink] = (0, react_1.useState)();
    const [nextLink, setNextLink] = (0, react_1.useState)();
    const setLinksToBar = (stepNumber) => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId;
        switch (stepNumber) {
            case 0:
                setBackLink(navigation_1.default.rightholder.createWork.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.submission(currentRightsholderId));
                setCurrentStepType('Create Work Form');
                break;
            case 1:
                setBackLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId)); // Done work details
                setCurrentStepType('Work Details');
                break;
            case 2:
                setBackLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.writersSharesRole(currentRightsholderId)); // Next
                setCurrentStepType('Writers - Add Writers');
                break;
            case 3:
                setBackLink(navigation_1.default.rightholder.createWork.form.writers(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId)); // Done writers
                setCurrentStepType('Writers - Add Roles');
                break;
            case 4:
                setBackLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.publishersShares(currentRightsholderId)); // Next
                setCurrentStepType('Publishers - Add Publishers');
                break;
            case 5:
                setBackLink(navigation_1.default.rightholder.createWork.form.publishers(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.publishersWriters(currentRightsholderId)); // Next
                setCurrentStepType('Publishers - Add Shares');
                break;
            case 6:
                setBackLink(navigation_1.default.rightholder.createWork.form.publishersShares(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId)); // Done publishers
                setCurrentStepType('Publishers - Link Writers & Publishers');
                break;
            case 7:
                setBackLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.form.root(currentRightsholderId)); // Done recordings
                setCurrentStepType('Recordings');
                break;
            case 8:
                setBackLink(navigation_1.default.rightholder.createWork.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.root(currentRightsholderId));
                setCurrentStepType('Submission');
                break;
            default:
                break;
        }
    };
    const getCurrentStep = () => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId;
        switch (location.pathname) {
            case navigation_1.default.rightholder.createWork.form.root(currentRightsholderId):
                return 0;
            case navigation_1.default.rightholder.createWork.form.workDetails(currentRightsholderId):
                return 1;
            case navigation_1.default.rightholder.createWork.form.writers(currentRightsholderId):
                return 2;
            case navigation_1.default.rightholder.createWork.form.writersSharesRole(currentRightsholderId):
                return 3;
            case navigation_1.default.rightholder.createWork.form.publishers(currentRightsholderId):
                return 4;
            case navigation_1.default.rightholder.createWork.form.publishersShares(currentRightsholderId):
                return 5;
            case navigation_1.default.rightholder.createWork.form.publishersWriters(currentRightsholderId):
                return 6;
            case navigation_1.default.rightholder.createWork.form.recordings(currentRightsholderId):
                return 7;
            case navigation_1.default.rightholder.createWork.form.submission(currentRightsholderId):
                return 8;
            default:
                return 0;
        }
    };
    const initWorkDraft = () => workStore.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_registration_new_work_form');
        initWorkDraft();
    }, []);
    (0, react_1.useEffect)(() => {
        const stepNumber = getCurrentStep();
        setCurrentStep(stepNumber);
        setLinksToBar(stepNumber);
    }, [location]);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: "Create work by form" }),
        react_1.default.createElement("div", { className: "create-work-scene" },
            react_1.default.createElement("div", { className: "global-container steps-wrapper" },
                currentStep !== 0 && currentStep !== 8 ? (react_1.default.createElement("div", { className: "head-create-work-wizard" },
                    react_1.default.createElement("h5", { title: workDraftFromLocal.title }, workDraftFromLocal.title),
                    react_1.default.createElement("h2", null, currentStepType),
                    react_1.default.createElement(WorkRegistrationWizardRoad_1.default, { currentStep: currentStep, onlyOneStep: true }))) : null,
                react_1.default.createElement(react_router_dom_1.Outlet, null),
                react_1.default.createElement(FormBottomNavBar_1.default, { nextLink: nextLink, backLink: backLink, hideBackLink: !!backLink, isFormStep: currentStep === 0, isSubmittedStep: currentStep === 8, isFinishEntityStep: nextLink ===
                        navigation_1.default.rightholder.createWork.form.root(rightsholderStore.currentRightsholderId) })))));
};
exports.default = CreateWorkByFormLayout;
